exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.popup[data-v-8055b97c] {\n  top: 0;\n  left: 0;\n  z-index: 1500;\n  position: absolute;\n  display: inline-grid;\n  grid-template-columns: auto auto;\n}\n.item-wrapper[data-v-8055b97c] {\n  margin: 5px;\n}\n", ""]);

// exports
